<template>
  <d-modal @close="handleClose">
    <d-modal-header @click.stop>
      <d-modal-title>
        {{ $t('contractorsSettlementsImportPopup.importTitle') }}
      </d-modal-title>
    </d-modal-header>
    <d-modal-body @click.stop>
      <d-form>
        <validation-observer ref="contractors-settlements-import-form" tag="form">
          <div class="form-group">
            <label for="name">
              {{ $t('contractorsSettlementsImportPopup.xlsxFile') }}:
            </label>

            <validation-provider
              rules="required"
              name="file"
              v-slot="{ errors }">
              <file-input
                :onChange="setNewFile"
                id="inputFileImport" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>
        </validation-observer>
      </d-form>
    </d-modal-body>
    <d-modal-footer @click.stop>
      <d-button
        class="ml-0"
        theme="danger"
        :disabled="importInProgress"
        @click.prevent.stop="cancel">
        {{ $t('ui.cancel') }}
      </d-button>
      <d-button
        class="ml-auto"
        theme="success"
        :disabled="importInProgress"
        @click.prevent.stop="validateForm">
        <div
          v-if="importInProgress"
          class="spinner-border spinner-border-sm"
          role="status"></div>
        {{ $t('ui.importFile') }}
      </d-button>
    </d-modal-footer>
  </d-modal>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';
import jsonToFormData from 'json-form-data';
import Vue from 'vue';

export default {
  name: 'contractors-settlements-import-popup',
  data () {
    return {
      file: null,
      importInProgress: false
    };
  },
  mounted () {
    this.file = null;
    this.importInProgress = false;
  },
  methods: {
    handleClose () {
      this.$bus.$emit('dashboard-contractors-settlements-import-popup-close');
    },
    validateForm () {
      FormUtils.validate(this.$refs['contractors-settlements-import-form'], this.import);
    },
    setNewFile (event) {
      this.file = event.target.files[0];
    },
    import () {
      this.importInProgress = true;

      this.$http.request({
        method: 'POST',
        url: '/orders/services/settlement-by-import',
        headers: {
          'Content-Type': undefined
        },
        transformRequest (data) {
          let dataToSend = jsonToFormData(data);
          return dataToSend;
        },
        data: {
          file: this.file
        }
      }).then(() => {
        this.cancel();
        this.importInProgress = false;

        Vue.swal({
          title: this.$t('contractorsSettlementsImportPopup.importSuccessTitle'),
          html: this.$t('contractorsSettlementsImportPopup.importSuccessDesc'),
          type: 'success',
          confirmButtonText: this.$t('ui.ok'),
          buttonsStyling: true
        });

        this.$bus.$emit('contractors-settlements-reload-needed');
      }).catch(error => {
        console.log(error);
        Vue.swal({
          title: this.$t('ui.importErrorTitle'),
          html: this.$t('ui.tryAgain'),
          type: 'warning',
          confirmButtonText: this.$t('ui.ok'),
          buttonsStyling: true
        });
        this.importInProgress = false;
      });
    },
    cancel () {
      this.handleClose();
    }
  }
}
</script>
